export const formatPrice = (num, shouldComplete) => {
  let price = ('' + num).replace(
    /(\d)(?=(?:\d{3})+(?:\.|$))|(\.\d\d?)\d*$/g,
    function (m, s1, s2) {
      return s2 || (s1 + ',');
    }
  );

  if (!price.includes('.') && shouldComplete) {
    price = `${price}.00`
  }

  if (shouldComplete && price.includes('.') && price.split('.')[1].length === 1) {
    price = `${price}0`
  }

  return price;
}